import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav, Container, Button } from 'react-bootstrap';

const Navbar = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'მთავარი', icon: 'fas fa-home' },
    { path: '/menu', label: 'მენიუ', icon: 'fas fa-utensils' },
    { path: '/reservation', label: 'დაჯავშნა', icon: 'fas fa-calendar-alt' },
    { path: '/about', label: 'ჩვენს შესახებ', icon: 'fas fa-info-circle' },
    { path: '/contact', label: 'კონტაქტი', icon: 'fas fa-envelope' }
  ];

  return (
    <BootstrapNavbar 
      bg="dark" 
      variant="dark" 
      expand="lg" 
      className="py-3"
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/" className="fw-bold fs-3">
          <i className="fas fa-utensils text-warning me-2"></i>
          ატმოსფერო
        </BootstrapNavbar.Brand>
        
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {navItems.map((item) => (
              <Nav.Link
                key={item.path}
                as={Link}
                to={item.path}
                className={`mx-2 ${location.pathname === item.path ? 'active text-warning' : ''}`}
                onClick={() => setExpanded(false)}
              >
                <i className={item.icon}></i> {item.label}
              </Nav.Link>
            ))}
          </Nav>
          
          <div className="ms-3">
            <Button 
              as={Link} 
              to="/reservation" 
              variant="warning" 
              className="fw-bold"
              onClick={() => setExpanded(false)}
            >
              <i className="fas fa-calendar-check me-2"></i>
              დაჯავშნა
            </Button>
          </div>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
